__turbopack_context__.v({
  "checkbox": "index-module-scss-module__2IKXwG__checkbox",
  "checkmark": "index-module-scss-module__2IKXwG__checkmark",
  "checkmark--checked": "index-module-scss-module__2IKXwG__checkmark--checked",
  "indicator": "index-module-scss-module__2IKXwG__indicator",
  "indicator--checked": "index-module-scss-module__2IKXwG__indicator--checked",
  "switch": "index-module-scss-module__2IKXwG__switch",
});
